import React, { useState, Fragment } from "react";
import {
  Tooltip, Overlay
} from 'react-bootstrap';
import {
  ClickAwayListener, Fade, Paper,
} from "@material-ui/core";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./rewritercss.css"
import "./script.js";
import { SnackbarProvider } from "notistack";
const axios = require('axios').default;

// const download = require("downloadjs");

const url = 'https://rewritertools.herokuapp.com/api/tools';


function ReWriter() {
  const [postData, setData] = useState('')
  const [rewrite, setRewrite] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tooltip, setTooltip] = useState({ obj: [], active: false, indexNo: 0 })
  const handleClickAway = () => {
    setTooltip(false);
  };

  let userData;

  let originaldata = Array.from(postData.split(" "));


  const handleFile = (e) => {
    const content = e.target.result;
    setData(String(content))
    // You can set content in state and show it in render.
  }
  
  const handleChangeFile = (file) => {
    let fileData = new FileReader();
    fileData.onloadend = handleFile;
    fileData.readAsText(file);
  }


  const suggestionsAdd = (value, index) => {

    let li = []

    li = Array.from(rewrite);
    
    li[tooltip.indexNo].unshift(value);
    
   
    // li[tooltip.indexNo].splice(index,index);

    setRewrite(li)
    


  }

  
  // download(postData, "Text.txt", "text/plain");

  const ValueAdd = (index) => {
    
    let li = []
    li = Array.from(rewrite)
    
    li[tooltip.indexNo].unshift(userData)
    setRewrite(li)
  }

  const mouseEnter = (obj, active, indexNo) => (event) => {
    setAnchorEl(event.target);
    setTooltip({ ...setTooltip, obj, active, indexNo });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    axios.post(url, {
      postData: postData
    })
      .then(function (response) {
        console.log(response.data);
        setRewrite(response.data.synonyms);
      })
      .catch(function (error) {
        console.log(error);
      });
    // console.log(postData)
  };
  return (
    <Fragment>

      <Fade timeout={350} addEndListener={handleClickAway}>
        <Paper>
          <Overlay target={anchorEl} show={tooltip.active} placement="bottom">
            {(props) => (
              <Tooltip
                className="emoji-tooltip"
                id="overlay-example-emoji"
                {...props}
                show={tooltip.toString()}
              >
                <ClickAwayListener onClickAway={handleClickAway}>
                  <div className="text-left p-3" style={{ width: "380px" }}>
                    <p className="suggestion"> <strong>Original Text: </strong> {tooltip.obj? originaldata[tooltip.indexNo]:""}</p>
                    Add your Own Word:
                    
                      <input className="input_word" onChange={(e) => userData=e.target.value} />
                      <a type="submit" onClick={ValueAdd} className="usebtn">USE</a>
                    
                    <p className="d-inline"><strong><br></br>Or Suggessions: </strong></p>
                    {(tooltip.obj && tooltip.obj.length > 1 && tooltip.obj.map((item, key) => {
                      return (
                        <Fragment key={key}>
                          <a type="submit"  onClick={() =>{suggestionsAdd(item, key)}}>
                            
                            <p className="suggestion">{item}, &nbsp;</p></a>
                          
                        </Fragment>
                        
                        
                      )
                    }))}
                    
                  </div>
                
                
                </ClickAwayListener>
              </Tooltip>
            )}
          </Overlay>
        </Paper>
      </Fade>


      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-5">
            <textarea className="text" rows="6" onChange={(e) => setData(e.target.value)}>
                   {originaldata}
            </textarea>
          </div>
          <div className="align-items-center justify-content-center col-md-2 d-flex">
            <button type="submit" className="button" >ReWrite</button>
          </div>
          <div className="col-md-5 text1">
            {(rewrite && rewrite.length > 0 && rewrite.map((obj, key) => {


              return (
                <Fragment key={key}>
                  {obj.length === 1 && (
                    <p className="float-left">{obj[0]}&nbsp;</p>
                  )}
                  {obj.length > 1 && (
                    
                    <p className="float-left font-weight-bold text-danger"
                      onClick={mouseEnter(obj, true, key)}
                    >{obj[0]}&nbsp;</p>
                    
                  )}
                
                </Fragment>
                  

              )
            }))}
            
          </div>
        </div>
      </form>
      <div className="row"> 
            <div className="col-md-5"> 
            <p>Word Count: {originaldata.length === 1 ? 0 : originaldata.length}</p>
            <input accept=".txt" onChange={e => handleChangeFile(e.target.files[0])} type="file"></input>
            </div>
            <div className="col-md-2"></div>
            <div className="col-md-5">

            <a href="/" className="share_box refresh_pages" data-toggle="tooltip" data-placement="top" title="Try New"></a>
            <a href="/" className="share_box print_pages" data-toggle="tooltip" data-placement="top" title="Print"></a>
            <a href="/" className="share_box download_pages" data-toggle="tooltip" data-placement="top" title="Download"></a>
            <a onClick={ () => {navigator.clipboard.writeText(postData)} } className="share_box copy_pages" data-toggle="tooltip" data-placement="top" title="Copy Content"></a>
            </div>
           
      </div>
    </Fragment>
  );
}

export default ReWriter;